import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Create context
const ThemeContext = createContext();

// Custom hook
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Provider
export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Load saved theme
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;

    console.log('Saved theme:', savedTheme);
    console.log('System prefers dark:', prefersDark);

    // Only apply saved theme preference
    if (savedTheme === 'dark') {
      console.log('Applying SAVED DARK theme');
      setIsDark(true);
      document.documentElement.setAttribute('data-theme', 'dark');
    } else if (savedTheme === 'light') {
      console.log('Applying SAVED LIGHT theme');
      setIsDark(false);
      document.documentElement.removeAttribute('data-theme');
    } else {
      // If no saved preference, DEFAULT TO LIGHT THEME (ignore system preference)
      console.log('Applying DEFAULT LIGHT theme (ignoring system preference)');
      setIsDark(false);
      document.documentElement.removeAttribute('data-theme');
      // Optionally save the default preference to localStorage
      localStorage.setItem('theme', 'light');
    }

    setIsInitialized(true);
  }, []);

  const toggleTheme = () => {
    const newDark = !isDark;
    setIsDark(newDark);

    if (newDark) {
      console.log('Toggling theme → DARK');
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      console.log('Toggling theme → LIGHT');
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem('theme', 'light');
    }
  };

  // Wait for theme to be initialized before rendering children
  if (!isInitialized) {
    return null; // or a loading spinner
  }

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ThemeContext;
